import { ChangeEvent } from 'react';
import './Slider.css';

interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  onChange: (value: number) => void;
}

/**
 * Reusable slider input component with label and value display
 * @param label - The label text
 * @param value - Current slider value
 * @param min - Minimum value
 * @param max - Maximum value
 * @param step - Step increment (default: 1)
 * @param unit - Unit suffix to display (optional)
 * @param onChange - Callback when value changes
 * @returns The rendered slider component
 */
function Slider({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}: SliderProps): JSX.Element {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    onChange(Number(e.target.value));
  };

  return (
    <div className="slider">
      <div className="slider-header">
        <span className="slider-label">{label}</span>
        <span className="slider-value">{value}{unit}</span>
      </div>
      <input
        type="range"
        className="slider-input"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default Slider;
